// extracted by mini-css-extract-plugin
export default {"flavor_option":"AV","out_of_stock_text":"BV","out_of_stock":"CV","flavor_option_image":"EV","flavor_option_info":"FV","flavor_option_title":"GV","flavor_option_limited":"HV","flavor_option_amount_wrapper":"IV","flavor_option_amount_button":"JV","zero_amount":"KV","no_flavors":"LV","no_flavors_active":"MV","flavor_option_select_wrapper":"NV","flavor_option_select_wrapper__selected":"OV"};
    if(module.hot) {
      // 1713996749800
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  